import React from 'react';
import { Icons } from '@casanova/casanova-common';

export const preventChangeConfig = {
  preventChange: true,
  onlyWhenCanceling: true,
  fullReload: true,
  icon: <Icons.Quote />,
};
